var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon20PxFolderOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.80078 15.839V4.20826C2.80078 3.91448 2.91748 3.63274 3.12522 3.425C3.33295 3.21727 3.61469 3.10057 3.90847 3.10057H7.99586C8.24889 3.0932 8.49682 3.17272 8.69837 3.32589C8.8999 3.47906 9.0429 3.69664 9.10355 3.94242L9.44693 5.31596H16.0931C16.3868 5.31596 16.6686 5.43265 16.8763 5.64039C17.084 5.84813 17.2008 6.12987 17.2008 6.42365V15.839C17.2008 16.1329 17.084 16.4145 16.8763 16.6222C16.6686 16.83 16.3868 16.9467 16.0931 16.9467H3.90847C3.61469 16.9467 3.33295 16.83 3.12522 16.6222C2.91748 16.4145 2.80078 16.1329 2.80078 15.839Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon20PxFolderOutline);
export default __webpack_public_path__ + "static/media/icon_20px_folder_outline.e662bdd70cfc94a3045113de32b50a52.svg";
export { ForwardRef as ReactComponent };